export const PRODUCT_ADJUSTMENT_MIN_VALUE = 0;
export const PRODUCT_ADJUSTMENT_MAX_VALUE = 1000000;
export const PRODUCT_ADJUSTMENT_MIN_COMMENT_LENGTH = 1;
export const PRODUCT_ADJUSTMENT_MAX_COMMENT_LENGTH = 10000;
export let PRODUCTS_QUANTITY_FILTER = /*#__PURE__*/function (PRODUCTS_QUANTITY_FILTER) {
  PRODUCTS_QUANTITY_FILTER["ALL"] = "allProducts";
  PRODUCTS_QUANTITY_FILTER["SHORTAGE"] = "shortage";
  PRODUCTS_QUANTITY_FILTER["OVERRAGE"] = "overage";
  return PRODUCTS_QUANTITY_FILTER;
}({});
export let PRODUCTS_EXPIRABLE = /*#__PURE__*/function (PRODUCTS_EXPIRABLE) {
  PRODUCTS_EXPIRABLE["ALL"] = "all";
  PRODUCTS_EXPIRABLE["EXPIRABLE"] = "expirable_products";
  PRODUCTS_EXPIRABLE["NON_EXPIRABLE"] = "non_expirable_products";
  return PRODUCTS_EXPIRABLE;
}({});
export const PRODUCTS_QUANTITY_FILTER_OPTIONS = [{
  value: PRODUCTS_QUANTITY_FILTER.ALL,
  label: 'All products'
}, {
  value: PRODUCTS_QUANTITY_FILTER.SHORTAGE,
  label: 'Shortage'
}, {
  value: PRODUCTS_QUANTITY_FILTER.OVERRAGE,
  label: 'Overage'
}];
export const PRODUCTS_EXPIRABLE_OPTIONS = [{
  value: PRODUCTS_EXPIRABLE.ALL,
  label: 'All product types'
}, {
  value: PRODUCTS_EXPIRABLE.EXPIRABLE,
  label: 'Expiring products'
}, {
  value: PRODUCTS_EXPIRABLE.NON_EXPIRABLE,
  label: 'Non-expiring products'
}];